import {
  InventoryCostingMethod,
  InventoryItemRecord,
  InventoryItemType,
  SaveInventoryItemRequest,
} from '@/renderer/types/inventory';

export interface InventoryItemFormState {
  sku: string;
  name: string;
  description: string;
  categoryId: string;
  newCategoryName: string;
  purchaseUnitId: string;
  newPurchaseUnitName: string;
  stockUnitId: string;
  newStockUnitName: string;
  conversionRate: string;
  costingMethod: InventoryCostingMethod;
  reorderLevel: string;
  itemType: InventoryItemType;
  isActive: boolean;
}

export const INVENTORY_COSTING_METHOD_OPTIONS: Array<{
  value: InventoryCostingMethod;
  label: string;
}> = [{ value: 'weighted_average', label: 'Weighted Average' }];

export const INVENTORY_ITEM_TYPE_OPTIONS: Array<{
  value: InventoryItemType;
  label: string;
}> = [
  { value: 'resale', label: 'Resale stock (recipe / menu-linked)' },
  { value: 'supply', label: 'Supplies & consumables (not for resale)' },
];

export const createEmptyInventoryItemForm = (): InventoryItemFormState => ({
  sku: '',
  name: '',
  description: '',
  categoryId: '',
  newCategoryName: '',
  purchaseUnitId: '',
  newPurchaseUnitName: '',
  stockUnitId: '',
  newStockUnitName: '',
  conversionRate: '1',
  costingMethod: 'weighted_average',
  reorderLevel: '0',
  itemType: 'resale',
  isActive: true,
});

export const createInventoryItemFormFromRecord = (
  record: InventoryItemRecord,
): InventoryItemFormState => ({
  sku: record.sku ?? '',
  name: record.name,
  description: record.description ?? '',
  categoryId: record.category_id ?? '',
  newCategoryName: '',
  purchaseUnitId: record.purchase_unit_id,
  newPurchaseUnitName: '',
  stockUnitId: record.stock_unit_id,
  newStockUnitName: '',
  conversionRate: String(record.conversion_rate),
  costingMethod: record.costing_method,
  reorderLevel: String(record.reorder_level),
  itemType: record.item_type,
  isActive: record.is_active,
});

export const buildSaveInventoryItemPayload = (
  companyId: number,
  form: InventoryItemFormState,
  id?: string,
): SaveInventoryItemRequest => ({
  id,
  companyId,
  sku: form.sku || null,
  name: form.name,
  description: form.description || null,
  categoryId: form.categoryId || null,
  purchaseUnitId: form.purchaseUnitId,
  stockUnitId: form.stockUnitId,
  conversionRate: Number(form.conversionRate || 1),
  costingMethod: form.costingMethod,
  reorderLevel: Number(form.reorderLevel || 0),
  itemType: form.itemType,
  isActive: form.isActive,
});
